export default {
  hideButtons: function (storyboard) {
    storyboard.DOM.toolbarButtons.style['opacity'] = '0'
    storyboard.DOM.toolbarButtons.classList.add('disabled')
  },

  showButtons: function (storyboard) {
    storyboard.DOM.toolbarButtons.style['opacity'] = '0.8'
    storyboard.DOM.toolbarButtons.classList.remove('disabled')

    const isFirstStep = storyboard.stepper.currentGlobalAnimationStep === 1
    if (isFirstStep) {
      storyboard.DOM.prevStep.classList.add('disabled')
    }
  }
}
